import { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import Sidebar from "../../../DesignSystem/Sidebar";
import Breadcrumb from "../../../DesignSystem/Breadcrumb/Breadcrumb";
import PrimaryButton from "../../../DesignSystem/Buttons/PrimaryButton";
import AdviserCatchUpPanel from "./AdviserCatchUpPanel";
import { subscribeAdviserFullDetailsByEmailOrId } from "../../../../context/Adviser/Utils/AdviserLiveDetails";
import { useUserPermissions } from "../../../SignIn/UserPermissionsContext";
import { useUserEmail } from "../../../SignIn/UserEmailContext";
import { isConfiguredAdviserCatchUpUser } from "./adviserCatchUpConfig";

export default function EditAdviserCatchUpPage() {
  const { state } = useLocation();
  const navigate = useNavigate();
  const params = useParams();
  const { userPermissions = [] } = useUserPermissions();
  const { userEmail } = useUserEmail();

  const rawKey =
    params.adviserKey || params.id || params.email || params.adviserId || "";
  const adviserKey = rawKey ? decodeURIComponent(rawKey) : "";
  const [details, setDetails] = useState(null);
  const [saving, setSaving] = useState(false);
  const [saveRequestKey, setSaveRequestKey] = useState(0);

  useEffect(() => {
    if (!adviserKey) return undefined;
    return subscribeAdviserFullDetailsByEmailOrId(adviserKey, setDetails);
  }, [adviserKey]);

  const loading = !details || details.loading;
  const adviserId = details?.adviserId || adviserKey;
  const canEdit =
    userPermissions.includes("Administrator") ||
    isConfiguredAdviserCatchUpUser(userEmail);

  return (
    <div className="main-content">
      <Helmet>
        <title>Edit Adviser Catch Up</title>
      </Helmet>

      <Sidebar />

      <div className="Main-Container">
        <div className="smProfilePage">
          <div className="smDetailsBreadcrumb">
            <Breadcrumb
              items={[
                { label: "All Staff", to: "/Department/AllStaff" },
                { label: "Advisers", to: "/Advisers" },
                {
                  label: "Adviser Catch Up",
                  to:
                    state?.returnTo ||
                    `/advisers/${encodeURIComponent(adviserKey)}?tab=adviserCatchUp`,
                },
                { label: "Edit" },
              ]}
            />
          </div>

          {loading ? (
            <div className="smLoading Content-Small">Loading Catch Up details...</div>
          ) : (
            <div className="smFeed">
              <div className="smEditActions">
                <div className="smEditActionsLeft">
                  <h3 className="FP_H3">Edit Adviser Catch Up</h3>
                </div>

                <PrimaryButton
                  label={saving ? "Saving..." : "Save"}
                  onClick={() => setSaveRequestKey((current) => current + 1)}
                  disabled={saving || !canEdit}
                />
              </div>

              <AdviserCatchUpPanel
                adviserId={adviserId}
                adviserDoc={details?.adviserDoc}
                canEdit={canEdit}
                canLogCatchUp={canEdit}
                onEdit={null}
                saveRequestKey={saveRequestKey}
                onSavingChange={setSaving}
                showSummary={false}
                onSaved={() =>
                  navigate(
                    state?.returnTo ||
                      `/advisers/${encodeURIComponent(adviserKey)}?tab=adviserCatchUp`,
                  )
                }
              />
            </div>
          )}

          {/* <div className="adviserCatchUpEditFooter">
            <SecondaryButton
              label="Back"
              onClick={() =>
                navigate(
                  state?.returnTo ||
                    `/advisers/${encodeURIComponent(adviserKey)}?tab=adviserCatchUp`,
                )
              }
            />
          </div> */}
        </div>
      </div>
    </div>
  );
}
